import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

import saga from './saga'
import reducer from './reducer'
import * as constants from './constants'

export { saga, constants, reducer }

export default Loadable(() => import('./ConditionAdd'))
